import { Injectable } from "@angular/core";
import { HttpClient, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class DealsService {
  constructor(private _httpClient: HttpClient) {
  }

  //lista offerte
  async getDeals() {
    return this._httpClient
      .get(`/deal`)
      .toPromise()
      .then((deals: any) => {
        return deals.map((deal: any) => {
          if (Array.isArray(deal.description)) {
            deal.description = deal.description.filter((i: any) => i);
          }
          return deal;
        });
      });
  }

  //singola offerta
  async getDeal(id: number) {
    return this._httpClient.get("/deal/" + id).toPromise();
  }

  //aggiungi offerta
  async addDeal(data: any = {}) {
    return this._httpClient.post("/deal", data).toPromise();
  }

  //modifica offerta
  async editDeal(id: number, data: any = {}) {
    return this._httpClient.put("/deal/" + id, data).toPromise();
  }

  //cancella offerta
  async deleteDeal(id: number) {
    return this._httpClient.delete("/deal/" + id).toPromise();
  }

  async generateDealDocument(id: number) {
    return this._httpClient.post(`/deal/document/generate/${id}`, {}).toPromise();
  }

  async duplicate(deal_id: number, name: number) {
    return this._httpClient.post(`/deal/duplicate/${deal_id}`, {name}).toPromise();
  }

  async uploadDocument(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `/deal/document/upload/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }
}
